import styled from "styled-components";

export const TextAreaContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    textarea {
        width: 100%;
        max-width: 400px;
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 16px;
        margin-top: 10px;
        color: #222;

        &:focus {
            outline: none;
            border-color: ${({theme}) => theme.colors.primaryBlue.hover};
            color: ${({theme}) => theme.colors.primaryBlue.hover};
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        &::-webkit-scrollbar {
            width: 0.4rem;
            height: 0.4rem;
            background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 50px;
            background-color: #bdbdbd;
        }
    }

    #counter {
        position: absolute;
        bottom: 0;
        right: 12px;
        font-size: 12px;
        color: #ccc;
    }
`;
